import React from 'react'
import PropTypes from 'prop-types'

import { News } from '../../../../../entities/News'

import { RCSectionBlock } from '../../../RCSectionBlock/RCSectionBlock'
import { RCMainArticleContent } from './RCMainArticleContent/RCMainArticleContent'
import { SideArticleContent } from './SideArticleContent/SideArticleContent'

import './RCArticleContent.css'

const RCArticleContent = ({ singleArticle, slug }) => (
    <RCSectionBlock withContainer>
        <div className="rc-article-content">
            <RCMainArticleContent article={singleArticle} />
            <SideArticleContent article={singleArticle} slug={slug} />
        </div>
    </RCSectionBlock>
)

RCArticleContent.propTypes = {
    singleArticle: PropTypes.instanceOf(News),
    slug: PropTypes.string
}

export { RCArticleContent }
